import {
  IconCaretDownFilled,
  IconCaretRightFilled,
  IconChartPieFilled,
  IconX,
} from "@tabler/icons-react";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  getChatNotifications,
  getSideBarChatNotifications,
  MarkSideBarChatNotifications,
} from "../../../services/user.services";
import { useSelector } from "react-redux";

// This contains the sidebar of the website
const Sidebar = ({ isOpen, setIsOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const StudentDetails = useSelector((state) => state.user.userDetails);
  const user_id = useSelector((state) => state.user.user_id);
  const sidebarRef = useRef(null);

  // Responsive state
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  // Determine which sections should be open based on current path
  const getInitialOpenSections = () => {
    const path = location.pathname;

    if (path.includes("/student/documents_upload")) {
      return [1];
    } else if (path.includes("/student/university_application_process")) {
      return [2];
    } else if (path.includes("/student/next_step_after_admit")) {
      return [3];
    } else if (path.includes("/student/visa_process")) {
      return [4];
    }

    return []; // No sections open by default
  };

  const [openSections, setOpenSections] = useState(getInitialOpenSections);
  const [messages, setMessages] = useState([]);

  // Window resize handler
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Check if current path is active
  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  const CATEGORY_TO_QUERY_ON = {
    cv_upload: "cv",
    shortlisting_of_universities: "shortlisting",
    sop: "sop",
    lor: "lor",
    ug_only: "ug",
    university_specific_sop: "university_specific_sop",
    final_documents_upload: "final_documents_upload",
    university_application_process: "university_application_process",
    visa_process: "visa_process",
  };

  // const normalizeKey = (categoryTitle) =>
  //   (CATEGORY_TO_QUERY_ON[categoryTitle] || categoryTitle || "")
  //     .toLowerCase()
  //     .trim();

  const documentsUploadSteps = [
    {
      name: "CV Upload",
      title: "cv_upload",
      path: "/student/documents_upload/cv_upload",
      map_to: "resume_cv_url",
    },
    {
      name: "Shortlisting of Universities",
      title: "shortlisting_of_universities",
      path: "/student/documents_upload/shortlisting_of_universities",
      map_to: "shortlisting",
    },
    {
      name: "SOP",
      title: "sop",
      path: "/student/documents_upload/sop",
      map_to: "sop_url",
    },
    {
      name: "LOR",
      title: "lor",
      path: "/student/documents_upload/lor",
      map_to: "lor_url",
    },
    {
      name: "UG Only (Common App/UCAS)",
      title: "ug_only",
      path: "/student/documents_upload/ug_only",
      map_to: "ug_only_doc_url",
    },
    {
      name: "University Specific SOP/Essays",
      title: "university_specific_sop",
      path: "/student/documents_upload/university_specific_sop",
      map_to: "university_essay_url",
    },
    {
      name: "Final Documents Upload",
      title: "final_documents_upload",
      path: "/student/documents_upload/final_documents_upload",
      map_to: "final_doc_urls",
    },
  ];

  const getNotifications = async () => {
    try {
      const res = await getChatNotifications();
      // ✅ FIX: Access the notifications array from the response
      const notifications = res.data?.notifications || [];
      setMessages(notifications);
    } catch (err) {
      console.error(err);
    }
  };
  // const getRoomName = (stepTitle) => {
  //   if (!studentId) return ""; // ✅ prevent cv_upload_undefined
  //   return `${stepTitle}_${studentId}`;
  // };

  const handleToggle = (section, pathname) => {
    setOpenSections((prevSections) =>
      prevSections.includes(section)
        ? prevSections.filter((s) => s !== section)
        : [...prevSections, section]
    );

    navigate(pathname);

    // Auto-close sidebar on mobile after navigation
    if (isMobile) {
      setTimeout(() => {
        setIsOpen(false);
      }, 300);
    }
  };

  // const getUnreadCount = (categoryTitle) => {
  //   return messages.filter(
  //     (msg) => msg.query_on === categoryTitle && !msg.is_read
  //   ).length;
  // };
  // const getUnreadCount = (categoryTitle) => {
  //   const key = normalizeKey(categoryTitle);

  //   return (messages || []).filter((msg) => {
  //     const q = (msg.query_on || "").toLowerCase().trim();
  //     return q === key && msg.is_read === false;
  //   }).length;
  // };
  // const getUnreadCount = (stepTitle) => {
  //   const room = getRoomName(stepTitle);
  //   if (!room) return 0;

  //   const roomLc = room.toLowerCase().trim();

  //   return (messages || []).filter((m) => {
  //     const r = (m.roomname || "").toLowerCase().trim();
  //     return r === roomLc && isUnread(m);
  //   }).length;
  // };

  // Update open sections when route changes
  useEffect(() => {
    setOpenSections(getInitialOpenSections());
  }, [location.pathname]);

  useEffect(() => {
    getNotifications();

    // Set up polling for notifications
    const interval = setInterval(() => {
      if (user_id) getNotifications();
    }, 60000); // Check every minute

    return () => clearInterval(interval);
  }, [user_id]);

  // Mark notifications as read for a specific title
  // const markNotificationsAsRead = async (title) => {
  //   try {
  //     // First check if there are any unread notifications for this title
  //     const hasUnreadNotifications = messages.some(
  //       (msg) => msg.query_on === title && !msg.is_read
  //     );

  //     if (hasUnreadNotifications) {
  //       // Call the service to mark notifications as read
  //       const response = await MarkSideBarChatNotifications();

  //       if (response) {
  //         // Update local state to reflect read status
  //         setMessages((prevMessages) =>
  //           prevMessages.map((msg) =>
  //             msg.query_on === title ? { ...msg, is_read: true } : msg
  //           )
  //         );
  //       }
  //     }
  //   } catch (error) {
  //     console.error("Error marking notifications as read:", error);
  //   }
  // };
  // const markNotificationsAsRead = async (roomName) => {
  //   try {
  //     const hasUnread = messages.some(
  //       (m) => m.roomname === roomName && m.is_read === false
  //     );

  //     if (!hasUnread) return;

  //     await MarkSideBarChatNotifications({
  //       mark_all: true,
  //       room_name: roomName,
  //     });

  //     setMessages((prev) =>
  //       prev.map((m) => (m.roomname === roomName ? { ...m, is_read: true } : m))
  //     );
  //   } catch (e) {
  //     console.error(
  //       "Error marking notifications as read:",
  //       e?.response?.data || e
  //     );
  //   }
  // };
  // const markNotificationsAsRead = async (stepTitle) => {
  //   try {
  //     const room = getRoomName(stepTitle);

  //     const hasUnread = (messages || []).some(
  //       (m) =>
  //         (m.roomname || "").toLowerCase().trim() === room.toLowerCase() &&
  //         m.is_read === false
  //     );

  //     if (!hasUnread) return;

  //     await MarkSideBarChatNotifications({
  //       mark_all: true,
  //       room_name: room,
  //     });

  //     // update UI immediately
  //     setMessages((prev) =>
  //       prev.map((m) => {
  //         const r = (m.roomname || "").toLowerCase().trim();
  //         return r === room.toLowerCase() ? { ...m, is_read: true } : m;
  //       })
  //     );
  //   } catch (e) {
  //     console.error(
  //       "Error marking notifications as read:",
  //       e?.response?.data || e
  //     );
  //   }
  // };
  // const markNotificationsAsRead = async (stepTitle) => {
  //   try {
  //     const room = getRoomName(stepTitle);
  //     if (!room) return;

  //     const roomLc = room.toLowerCase().trim();

  //     const unreadInRoom = (messages || []).some((m) => {
  //       const r = (m.roomname || "").toLowerCase().trim();
  //       return r === roomLc && isUnread(m);
  //     });

  //     if (!unreadInRoom) return;

  //     await MarkSideBarChatNotifications({
  //       mark_all: true,
  //       room_name: room,
  //     });

  //     // ✅ optimistic UI update
  //     setMessages((prev) =>
  //       (prev || []).map((m) => {
  //         const r = (m.roomname || "").toLowerCase().trim();
  //         return r === roomLc ? { ...m, is_read: true } : m;
  //       })
  //     );

  //     // ✅ optional: sync from server (recommended)
  //     await getNotifications();
  //   } catch (e) {
  //     console.error(
  //       "Error marking notifications as read:",
  //       e?.response?.data || e
  //     );
  //   }
  // };
  const markNotificationsAsRead = async (stepTitle) => {
    try {
      // Get the normalized key from CATEGORY_TO_QUERY_ON
      const key = (CATEGORY_TO_QUERY_ON[stepTitle] || stepTitle || "")
        .toLowerCase()
        .trim();

      if (!key) return;

      // Check if there are any unread notifications for this key
      const unreadInStep = (messages || []).some((m) => {
        const q = String(m?.query_on || "")
          .toLowerCase()
          .trim();
        return q === key && isUnread(m);
      });

      if (!unreadInStep) return;

      // Mark notifications as read using the query_on value
      await MarkSideBarChatNotifications({
        mark_all: true,
        query_on: key, // Use query_on instead of room_name
      });

      // ✅ optimistic UI update
      setMessages((prev) =>
        (prev || []).map((m) => {
          const q = String(m?.query_on || "")
            .toLowerCase()
            .trim();
          return q === key ? { ...m, is_read: true } : m;
        })
      );

      // ✅ optional: sync from server (recommended)
      await getNotifications();
    } catch (e) {
      console.error(
        "Error marking notifications as read:",
        e?.response?.data || e
      );
    }
  };
  const studentId =
    StudentDetails?.id ||
    StudentDetails?.student_id ||
    StudentDetails?.user_id ||
    user_id;

  const normalizeRoom = (v) =>
    String(v || "")
      .toLowerCase()
      .trim();

  const isUnread = (m) =>
    m?.is_read === false || m?.is_read === 0 || m?.is_read === "false";

  const getUnreadCount = (stepTitle) => {
    const key = (CATEGORY_TO_QUERY_ON[stepTitle] || stepTitle || "")
      .toLowerCase()
      .trim();

    return (messages || []).filter((m) => {
      const q = String(m?.query_on || "")
        .toLowerCase()
        .trim();
      return q === key && isUnread(m);
    }).length;
  };

  const getRoomName = (stepTitle) => {
    if (!studentId) return "";
    return `${stepTitle}_${studentId}`;
  };

  // ✅ build unread count map once per messages change
  const unreadByRoom = React.useMemo(() => {
    const map = {};
    (messages || []).forEach((m) => {
      if (!isUnread(m)) return;
      const room = normalizeRoom(m.roomname);
      if (!room) return;
      map[room] = (map[room] || 0) + 1;
    });
    return map;
  }, [messages]);

  // const getUnreadCount = (stepTitle) => {
  //   const room = normalizeRoom(getRoomName(stepTitle));
  //   return room ? unreadByRoom[room] || 0 : 0;
  // };

  return (
    <>
      <div
        ref={sidebarRef}
        className={`
          ${isOpen ? "translate-x-0" : "-translate-x-full"} 
          fixed lg:flex left-0 top-0 md:w-80 h-screen 
          bg-gradient-to-b from-indigo-50 to-white 
          transition-transform duration-300 ease-in-out 
          shadow-lg flex flex-col z-40
        `}
      >
        {/* Mobile close button */}
        {isMobile && isOpen && (
          <button
            className="absolute top-4 right-4 p-1 rounded-full bg-indigo-100 text-indigo-600 hover:bg-indigo-200 z-50"
            onClick={() => setIsOpen(false)}
            aria-label="Close sidebar"
          >
            <IconX size={20} />
          </button>
        )}

        <div className="flex flex-col justify-start w-full h-full overflow-hidden">
          {/* Logo */}
          <div className="flex justify-center items-center mb-4 w-full">
            <img
              src="/logo.png"
              alt="logo"
              className="h-16 md:h-20 object-fit"
            />
          </div>

          {/* Scrollable content */}
          <div
            className="md:h-custom pt-6 overflow-y-auto flex-grow"
            style={{ maxHeight: "calc(100vh - 180px)" }}
          >
            {/* Status button */}
            <div className="flex justify-center mb-4">
              <button
                className={`
                  group w-11/12 flex items-center 
                  ${
                    isActive("/student/status")
                      ? "bg-indigo-600"
                      : "bg-indigo-500"
                  } 
                  hover:bg-indigo-600 text-white mb-2 px-6 py-3 
                  rounded-xl transition-all duration-300 hover:scale-105 shadow-md
                `}
                onClick={() => {
                  navigate("/student/status");
                  if (isMobile) setIsOpen(false);
                }}
              >
                <span className="group-hover:animate-pulse">
                  <IconChartPieFilled stroke={2} />
                </span>
                <span className="ml-4 font-semibold text-xl">Status</span>
              </button>
            </div>

            {/* Process sections */}
            <div>
              <h2 className="text-lg font-semibold text-indigo-700 mb-3 px-3">
                Process
              </h2>

              {/* Document Uploads Section */}
              <div className="mb-2">
                <button
                  className={`
                    flex justify-between items-center w-full px-4 py-2 text-lg text-left 
                    ${
                      openSections.includes(1)
                        ? "bg-indigo-100 text-indigo-800 rounded-lg"
                        : "text-gray-800 hover:bg-gray-100 hover:rounded-lg"
                    } 
                    transition-all duration-300 hover:scale-105
                  `}
                  onClick={() =>
                    handleToggle(1, "/student/documents_upload/cv_upload")
                  }
                >
                  <span className="flex items-center">
                    <span className="w-6 h-6 flex items-center justify-center bg-indigo-600 text-white text-xs rounded-full mr-2">
                      1
                    </span>
                    <span>Document Uploads</span>
                  </span>
                  <span>
                    {openSections.includes(1) ? (
                      <IconCaretDownFilled
                        stroke={2}
                        className="text-indigo-600"
                      />
                    ) : (
                      <IconCaretRightFilled stroke={2} />
                    )}
                  </span>
                </button>

                {/* Document upload steps */}
                {openSections.includes(1) && (
                  <ul className="ml-4 mt-2 space-y-2 relative text-gray-600">
                    {documentsUploadSteps.map((step, index) => {
                      // const unreadCount = getUnreadCount(step.title);
                      const isStepActive = isActive(step.path);
                      const isCompleted = Boolean(StudentDetails[step.map_to]);
                      const unreadCount = getUnreadCount(step.title);

                      return (
                        <li
                          key={index}
                          className={`
                            flex items-center justify-between hover:bg-gray-100 
                            ${
                              isStepActive
                                ? "bg-indigo-50 text-indigo-800"
                                : "text-gray-600"
                            } 
                            transition-colors duration-200 cursor-pointer rounded-lg px-3 py-2
                          `}
                          onClick={() => {
                            markNotificationsAsRead(step.title);
                            navigate(step.path);
                            if (isMobile) setIsOpen(false);
                          }}
                        >
                          <div className="flex items-center w-full">
                            <div className="relative">
                              {isCompleted ? (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-4 w-4 text-green-500"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              ) : (
                                <span
                                  className={`block w-2.5 h-2.5 ${
                                    isStepActive
                                      ? "bg-indigo-500"
                                      : "bg-gray-400"
                                  } rounded-full`}
                                ></span>
                              )}
                              {index < documentsUploadSteps.length - 1 && (
                                <div className="absolute top-3 left-1 w-px h-8 bg-gray-300"></div>
                              )}
                            </div>
                            <span
                              className={`ml-4 ${
                                isCompleted ? "text-green-600 font-medium" : ""
                              }`}
                            >
                              {step.name}
                            </span>
                          </div>

                          {unreadCount > 0 && (
                            <span className="flex-shrink-0 bg-red-500 text-white text-xs h-5 w-5 flex items-center justify-center rounded-full leading-none">
                              {unreadCount}
                            </span>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>

              {/* University Application Process Section */}
              <div className="mt-4">
                <button
                  className={`
                    flex justify-between items-center w-full px-4 py-2 text-lg text-left 
                    ${
                      openSections.includes(2)
                        ? "bg-indigo-100 text-indigo-800 rounded-lg"
                        : "text-gray-800 hover:bg-gray-100 hover:rounded-lg"
                    } 
                    transition-all duration-300 hover:scale-105
                  `}
                  onClick={() =>
                    handleToggle(2, "/student/university_application_process")
                  }
                >
                  <span className="flex items-center">
                    <span className="w-6 h-6 flex items-center justify-center bg-indigo-600 text-white text-xs rounded-full mr-2">
                      2
                    </span>
                    <span>University Application Process</span>
                  </span>
                  <span>
                    {openSections.includes(2) ? (
                      <IconCaretDownFilled
                        stroke={2}
                        className="text-indigo-600"
                      />
                    ) : (
                      <IconCaretRightFilled stroke={2} />
                    )}
                  </span>
                </button>

                {/* University Application Process Steps */}
                {openSections.includes(2) && (
                  <ul className="ml-4 mt-2 space-y-2 text-gray-600">
                    {[
                      {
                        name: "Application Process sent",
                        map_to: "is_show_table_to_student",
                      },
                      {
                        name: "Applications Submitted",
                        statusCheck: (details) =>
                          details.is_finalized_excel?.some((item) =>
                            [
                              "Submitted",
                              "Accepted",
                              "Finalized",
                              "Approved",
                            ].includes(item.status)
                          ),
                      },
                      {
                        name: "Decision Received",
                        statusCheck: (details) =>
                          details.is_finalized_excel?.some((item) =>
                            ["Approved", "Accepted", "Finalized"].includes(
                              item.status
                            )
                          ),
                      },
                      {
                        name: "University Finalized",
                        statusCheck: (details) =>
                          details.is_finalized_excel?.some(
                            (item) => item.status === "Finalized"
                          ),
                      },
                    ].map((step, index) => {
                      // Determine if step is complete
                      let isCompleted = false;

                      // 1) If step has a `map_to` property, check StudentDetails[map_to].
                      if (step.map_to) {
                        isCompleted = Boolean(StudentDetails[step.map_to]);
                      }

                      // 2) If step has a `statusCheck` property, check if any row in
                      //    `is_finalized_excel` has a matching status.
                      if (
                        step.statusCheck &&
                        step.statusCheck(StudentDetails)
                      ) {
                        isCompleted = true;
                      }

                      return (
                        <li
                          key={index}
                          className="flex items-center hover:bg-gray-100 hover:text-gray-800 transition-colors duration-200 cursor-pointer rounded-lg px-3 py-2"
                          onClick={() => {
                            navigate("/student/university_application_process");
                            if (isMobile) setIsOpen(false);
                          }}
                        >
                          <div className="relative">
                            {isCompleted ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4 text-green-500"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            ) : (
                              <span className="block w-2.5 h-2.5 bg-gray-400 rounded-full"></span>
                            )}
                            {index < 3 && (
                              <div className="absolute top-3 left-1 w-px h-8 bg-gray-300"></div>
                            )}
                          </div>
                          <span
                            className={`ml-4 ${
                              isCompleted ? "text-green-600 font-medium" : ""
                            }`}
                          >
                            {step.name}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>

              {/* Next Steps after Admit Section */}
              <div className="mt-4">
                <button
                  className={`
                    flex justify-between items-center w-full px-4 py-2 text-lg text-left 
                    ${
                      openSections.includes(3)
                        ? "bg-indigo-100 text-indigo-800 rounded-lg"
                        : "text-gray-800 hover:bg-gray-100 hover:rounded-lg"
                    } 
                    transition-all duration-300 hover:scale-105
                  `}
                  onClick={() =>
                    handleToggle(3, "/student/next_step_after_admit")
                  }
                >
                  <span className="flex items-center">
                    <span className="w-6 h-6 flex items-center justify-center bg-indigo-600 text-white text-xs rounded-full mr-2">
                      3
                    </span>
                    <span>Next Steps after Admit</span>
                  </span>
                  <span>
                    {openSections.includes(3) ? (
                      <IconCaretDownFilled
                        stroke={2}
                        className="text-indigo-600"
                      />
                    ) : (
                      <IconCaretRightFilled stroke={2} />
                    )}
                  </span>
                </button>

                {/* Next Steps after Admit Content */}
                {openSections.includes(3) && (
                  <ul className="ml-4 mt-2 space-y-2 text-gray-600">
                    <li className="text-sm text-gray-500 italic px-3 py-2">
                      No steps available yet
                    </li>
                  </ul>
                )}
              </div>

              {/* Visa Process Section */}
              <div className="mt-4">
                <button
                  className={`
                    flex justify-between items-center w-full px-4 py-2 text-lg text-left 
                    ${
                      openSections.includes(4)
                        ? "bg-indigo-100 text-indigo-800 rounded-lg"
                        : "text-gray-800 hover:bg-gray-100 hover:rounded-lg"
                    } 
                    transition-all duration-300 hover:scale-105
                  `}
                  onClick={() => handleToggle(4, "/student/visa_process")}
                >
                  <span className="flex items-center">
                    <span className="w-6 h-6 flex items-center justify-center bg-indigo-600 text-white text-xs rounded-full mr-2">
                      4
                    </span>
                    <span>Visa Process</span>
                  </span>
                  <span>
                    {openSections.includes(4) ? (
                      <IconCaretDownFilled
                        stroke={2}
                        className="text-indigo-600"
                      />
                    ) : (
                      <IconCaretRightFilled stroke={2} />
                    )}
                  </span>
                </button>

                {/* Visa Process Content */}
                {openSections.includes(4) && (
                  <ul className="ml-4 mt-2 text-gray-600">
                    <li className="text-sm text-gray-500 italic px-3 py-2">
                      No steps available yet
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </div>

          {/* Resources Button */}
          <div className="w-full mt-auto px-4 pb-4 pt-2 bg-indigo-50 sticky bottom-0 left-0">
            <button
              className="w-full bg-green-500 hover:bg-green-600 text-white text-lg font-semibold py-3 rounded-xl shadow-md transition-all duration-300"
              onClick={() => {
                navigate("/student/resources");
                if (isMobile) setIsOpen(false);
              }}
            >
              Resources
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Backdrop - Only show on mobile when sidebar is open */}
      {isMobile && isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
          onClick={() => setIsOpen(false)}
          aria-hidden="true"
        />
      )}
    </>
  );
};

export default Sidebar;
